import React from 'react';
import ChatApp from './components/ChatApp';
import { ThemeProvider } from './contexts/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <ChatApp />
      </div>
    </ThemeProvider>
  );
}

export default App;